// // ** Custom Icon Import
// import Icon from 'src/@core/components/icon'

// const UserIcon = ({ icon, ...rest }) => {
//   return <Icon icon={icon} {...rest} />
// }

// export default UserIcon


import Icon from 'src/@core/components/icon'

const UserIcon = ({ icon, color = '2E0F14', fontSize = '1.375rem', ...rest }) => {
  return <Icon icon={icon} style={{ color, fontSize }} {...rest} />
}

export default UserIcon

